import { Flex, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import ContentStatisticsTable from '../../../components/tables/ContentStatisticsTable'
import ContentTable from '../../../components/tables/ContentTable'

interface ContentPageProps {
  selectedTab?: 'library' | 'statistics'
}

const ContentPage: React.FC<ContentPageProps> = ({ selectedTab }) => {
  const [isScrolled, setIsScrolled] = useState(false)
  const location = useLocation()
  const activeTab = selectedTab ?? (location.pathname.includes('/statistics') ? 'statistics' : 'library')

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%">
        {activeTab === 'statistics' ? <ContentStatisticsTable /> : <ContentTable />}
      </VStack>
    </Flex>
  )
}

export default ContentPage
